import { appendAudit } from "./audit";

export const onNodeClick = (
  ev,
  button,
  selectedHandle,
  nodeRef,
  positions,
  setPositions,
  updateNodeInternals,
  data,
  grefs,
  dispatch,
  actionTypes,
  mode,
  nodes
) => {
  if (selectedHandle) {
    const box = nodeRef.current.getBoundingClientRect();
    const middleX = box.left + box.width / 2;
    const middleY = box.top + box.height / 2;
    const candidates = [
      ev.clientX < middleX ? "Left" : "Right",
      ev.clientY < middleY ? "Top" : "Bottom",
    ].filter((item) => {
      return positions["target"] !== item && positions["source"] !== item;
    });

    const newPositions = { ...positions, [selectedHandle]: candidates[0] };
    setPositions(newPositions);
    updateNodeInternals(data.id);

    //update handles
    const copyHandles = { ...grefs.handleRef.current };
    copyHandles[data.id] = {
      source: newPositions.source,
      target: newPositions.target,
    };
    grefs.handleRef.current = copyHandles;
  } else {
    //get next node
    const targets = grefs.edgeCollectionRef.current.filter((edge) => {
      return edge.source === data.id;
    });
    
    if (mode === "flow") {
      grefs.selectedRef.current[data.id] = {};
    }

    const actionTarget = (target) => {
      const newActiveNode = grefs.nodeCollectionRef.current.find(
        (node) => node.id === target
      );
      newActiveNode.position =
        grefs.calculatedPositionsRef.current[newActiveNode.id];

      if (!nodes.map((node) => node.id).includes(target)) {
        const activeNodes = nodes.concat([newActiveNode]);

        if (mode === "flow") {
          grefs.ignoreNodeChange.current = true;
          grefs.focusRef.current = target;
        }
        dispatch({
          type: actionTypes.SET_NODES,
          payload: activeNodes,
        });
      } else {
        if (mode === "flow") {
          dispatch({ type: actionTypes.SET_FOCUSID, payload: target });
        }
      }
    };

    switch (button) {      
      case "next":
        if (targets.length > 0) {
          const target = targets[0].target;
          // if (data.type !== "screenshot") {
            appendAudit(grefs, data.id, button, target);
          // }
          actionTarget(target);
        }
        break;
      case "yes":
        const yesNode = targets.find((node) => node.label === "Yes");
        if (yesNode) {
          //add new active node
          const target = yesNode.target;
          appendAudit(grefs, data.id, button, target);
          actionTarget(target);
        }
        break;
      case "no":
        const noNode = targets.find((node) => node.label === "No");
        if (noNode) {
          //add new active node
          const target = noNode.target;
          appendAudit(grefs, data.id, button, target);
          actionTarget(target);
        }
        break;
      default:
        console.log("default", button);
    }
  }
};
